import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import PageRenderer from "./components/PageRenderer";

// JSON данные
import mainData from "./pages/main.json";
import betData from "./pages/bet.json";
import loginData from "./pages/login.json";
import appData from "./pages/app.json";
import casinoData from "./pages/casino.json";
import slotsData from "./pages/slots.json";
import gamesData from "./pages/games.json";
import bonusData from "./pages/bonus.json";
import aviatorData from "./pages/aviator.json";

function App() {
  const routes = [
    { path: "/", label: "55BB", data: mainData },
    { path: "/apostas/", label: "Apostas", data: betData },
    { path: "/login/", label: "Login", data: loginData },
    { path: "/app/", label: "App", data: appData },
    { path: "/cassino/", label: "Cassino", data: casinoData },
    { path: "/slots/", label: "Slots", data: slotsData },
    { path: "/games/", label: "Games", data: gamesData },
    { path: "/bonus/", label: "Bonus", data: bonusData },
    { path: "/aviator/", label: "Aviator", data: aviatorData },
  ].filter((r) => r.data && Object.keys(r.data).length > 0); // 🚀 фильтр по пустым json

  return (
    <Router>
      <Header routes={routes} /> {/* теперь меню рендерится по данным */}
      <Routes>
        {routes.map((r, i) => (
          <Route
            key={i}
            path={r.path}
            element={<PageRenderer data={r.data} />}
          />
        ))}
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
